export default "__VITE_ASSET__e7daa43f__"